import type { PiletApi } from '@chess/platform-web';
import { CHESS_API, type Chess } from '@chess/api-chess';
import { LOG_API, type Log } from '@chess/api-log';
import { OPENINGS_API, type BookData } from '@chess/api-openings';
import { createOpenings, rulesFrom, type BookFile } from './openings';
import e4Url from './data/e4.json?url';
import otherUrl from './data/other.json?url';

// Provides `openings` from the Lichess data set (CC0), shipped as two assets
// beside this bundle: e4.json for every line that starts 1. e4, other.json
// for the rest. A game fetches the one its first move selects, once.
// `?url` makes each import the file's address, not its contents.
const urls: Record<BookFile, string> = { e4: e4Url, other: otherUrl };

export function setup(app: PiletApi) {
  const log = app.getApi<Log>(LOG_API).then((l) => l.child(app.meta.name));
  app.registerApi(
    OPENINGS_API,
    createOpenings({
      async fetchData(file) {
        (await log).debug('fetching opening book', { file });
        const response = await fetch(urls[file]);
        if (!response.ok) throw new Error(`opening book ${file}: HTTP ${response.status}`);
        return (await response.json()) as BookData;
      },
      rules: async () => rulesFrom(await app.getApi<Chess>(CHESS_API)),
      log: { debug: (msg, fields) => void log.then((l) => l.debug(msg, fields)) },
    }),
  );
}
